module.exports = __webpack_public_path__ + "img/ElectricMap.870c8439.png";